import { render, staticRenderFns } from "./TheEditAddressPanel.vue?vue&type=template&id=063157ca&scoped=true"
import script from "./TheEditAddressPanel.vue?vue&type=script&lang=js"
export * from "./TheEditAddressPanel.vue?vue&type=script&lang=js"
import style0 from "./TheEditAddressPanel.vue?vue&type=style&index=0&id=063157ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063157ca",
  null
  
)

export default component.exports